export const copy = {
  PasswordMeter: {
    passwordRequirementSubheading: "Password requirement",
  },
};
